import React from 'react';
import { useNavigate } from 'react-router-dom';
import { mockData } from '../mock';

const FinalCTA = () => {
  const navigate = useNavigate();
  
  return (
    <section className="relative min-h-screen bg-jet-black overflow-hidden flex items-center justify-center">
      {/* Full-Screen Takeover Background */}
      <div className="absolute inset-0">
        {/* Animated Grid */}
        <div className="absolute inset-0 bg-grid-pattern opacity-20 animate-pulse"></div>
        
        {/* Massive Gradient Orbs */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-electric-blue/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-neon-green/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
        
        {/* Energy Lines */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-electric-blue via-neon-green to-transparent opacity-50"></div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center rotate-90">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-neon-green via-electric-blue to-transparent opacity-30"></div>
        </div>
      </div>

      {/* Glowing Neon Border */}
      <div className="absolute inset-8 border-4 border-transparent bg-gradient-to-r from-electric-blue via-neon-green to-electric-blue bg-clip-border rounded-3xl opacity-50">
        <div className="absolute inset-1 bg-jet-black rounded-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        {/* Main Headline */}
        <h1 className="display-hero mb-8 animate-slide-power">
          {mockData.finalCTA.title}
        </h1>

        {/* Subtitle */}
        <p className="text-energy text-2xl md:text-3xl mb-12 animate-slide-power delay-200 max-w-3xl mx-auto">
          {mockData.finalCTA.subtitle}
        </p>

        {/* Giant CTA Button */}
        <div className="animate-slide-power delay-400">
          <button 
            onClick={() => navigate('/register')}
            className="group relative overflow-hidden bg-gradient-primary text-white border-none rounded-full px-16 py-8 font-black text-2xl md:text-3xl uppercase tracking-wide cursor-pointer transition-all duration-300 hover:scale-110 neon-border animate-pulse-power"
          >
            {/* Button Glow Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-electric-blue/50 to-neon-green/50 rounded-full blur-xl group-hover:blur-2xl transition-all duration-300"></div>
            
            {/* Button Text */}
            <span className="relative z-10">{mockData.finalCTA.cta}</span>
            
            {/* Energy Ripples */}
            <div className="absolute inset-0 border-4 border-white/20 rounded-full animate-ping"></div>
            <div className="absolute inset-0 border-2 border-white/10 rounded-full animate-ping" style={{animationDelay: '0.5s'}}></div>
          </button>
        </div>

        {/* Power Statement */}
        <div className="mt-16 animate-slide-power delay-600">
          <p className="text-energy text-xl mb-4">
            Join thousands of people who chose greatness over comfort
          </p>
          <p className="text-standard text-gray-400">
            Your transformation begins the moment you decide to stop settling.
          </p>
        </div>

        {/* Subtle Energy Waves */}
        <div className="absolute -inset-20 pointer-events-none opacity-30">
          <div className="absolute inset-0 border border-neon-green/5 rounded-full animate-pulse" style={{animationDuration: '4s'}}></div>
          <div className="absolute inset-8 border border-electric-blue/5 rounded-full animate-pulse" style={{animationDuration: '5s', animationDelay: '2s'}}></div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;